import { ReactNode } from 'react';
import styled from 'styled-components';
import { BouColor } from '../../../global/bou-colors';
import { BouCheckBox } from '../bou-check-box';
import { CheckBoxLabelPosition } from './types';

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: ReactNode;
  disabled?: boolean;
  labelPosition?: CheckBoxLabelPosition;
  className?: string;
}

export const BouCheckBoxWithLabel = (props: Props) => {
  const disabled = props.disabled || false;
  const labelPosition = props.labelPosition;

  return (
    <Root
      onClick={() => props.onChange(!props.checked)}
      disabled={disabled}
      labelPosition={labelPosition}
      className={props.className}
    >
      <BouCheckBox disabled={props.disabled} checked={props.checked} onChange={props.onChange} size="1.2em" />
      <Label disabled={disabled}>{props.label}</Label>
    </Root>
  );
};

const Root = styled.div<{ disabled: boolean; labelPosition?: CheckBoxLabelPosition }>`
  position: relative;
  display: flex;
  flex-direction: ${props => (props.labelPosition === CheckBoxLabelPosition.LEFT ? 'row-reverse' : 'row')};
  align-items: center;
  > * + * {
    padding-left: ${props => (props.labelPosition === CheckBoxLabelPosition.LEFT ? '0' : '0.8em')};
    padding-right: ${props => (props.labelPosition === CheckBoxLabelPosition.LEFT ? '0.5em' : '0')};
  }
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  color: ${props => (props.disabled ? BouColor.DARK_GRAY_NO_ALPHA : 'inherit')};
  &:hover {
    color: ${props => (props.disabled ? BouColor.DARK_GRAY_NO_ALPHA : BouColor.TOOL_TEXT_LIGHT_GRAY)};
  }
`;

const Label = styled.label<{ disabled: boolean }>`
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
`;
